import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';

export const StyledGridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "media" "content";
  padding: 0 2rem;

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: 2fr 3fr;
    grid-template-areas: "content media";
    padding: 0 11rem;
    grid-column-gap: ${themeGet('scale.scaleUp04')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
    grid-template-columns: 1fr 1fr;
    padding: 0 5rem;
  }
`;


export const StyledHeader = styled.header`
  padding-top: 46px;
  padding-bottom: 48px;
  background: ${themeGet('color.colorBlueLightest')};
  text-align: center;

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding-top: 110px;
    padding-bottom: 60px;

    .row {
      max-width: 1260px;
      grid-template-columns: 6fr 6.5fr;
      padding: 0px 32px;
    }
  }
`;

export const StyledHeroContent = styled.div`
  grid-area: content;
  align-items: flex-start;

  h1, h3 {
    text-align: center;
  }

  .supertext {
    ${themeGet('font.whitneySemibold')};
    color: ${themeGet('colorNew.blueLight')};
    font-size: 18px;
    margin-bottom: 16px;
  }
  h1 {
    color: ${themeGet('colorNew.blueDark')};
    margin-bottom: 0;
    font-size: 2.35rem;
    font-family: "Whitney Cond SSm A", "Whitney Cond SSm B", sans-serif;
    line-height: 2.75rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }
  h3 {
    margin-top: 0;
  }

  p {
    color: #121C2D;
    line-height: 2rem;
  }
  .btn-list {
    justify-content: left;
    padding: 0 2rem;
  }
  .hero__subhead {
    margin-top: 0.5rem;
    font-size: 18px;
    font-weight: 300;
    color: #030b5d;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1, h3 {
      margin-top: 0;
      text-align: left;
    }

    h1 {
      font-size: 3.25rem;
      line-height: 1;
      line-height: 3.5rem;
      margin-bottom: 1rem;
    }

    .btn-list {
      justify-content: left;
      padding: 0;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1131px)  {
    h1 {
      font-size: 2.9rem;
    }
  }
`;

export const StyledHeroMedia = styled.div`
  grid-area: media;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const StyledButtonList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-direction: column;

  .btn {
    width:50%;
    margin: ${themeGet('scale.scaleDown02')} auto;

    &:first-child {
      margin-top: 0;
      margin-left: auto;
    }

    &:last-child {
      margin-top: 0;
      margin-right: auto;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    //flex-direction: row;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    justify-content: start;

    .btn {
      width: auto;
      margin-right: ${themeGet('scale.scaleDown02')};
      margin-left: ${themeGet('scale.scaleDown02')};
  
      &:first-child {
        margin-left: 0;
      }
  
      &:last-child {
        margin-top: 0;
        margin-right: 0;
      }
    }
  }
`;

export const StyledCta = styled.div`
  grid-area: cta;
  text-align: center;
  margin-top: 10px;

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    text-align: left;
    margin-bottom: auto;
  }
`;